import { FormGroup } from '@angular/forms';
import { Schema, Content, LanguageModel, SquidexDate } from '../../services';
import { Validation } from '../../tools';
declare var CKEDITOR: any;

export class FormGroupMapper {

  public static GetContentFromFormGroup(
    formGroup: FormGroup,
    content: Content,
    schema: Schema,
    availableLanguages: LanguageModel[]): Content {

      if (!content.data) {
        content.data = {};
      }

      schema.fields.forEach(schemaField => {
        let formGroupValue = formGroup.value[schemaField.name];

        if (schemaField.partitioning !== 'language' && typeof (formGroupValue) !== 'undefined') {
          if (!content.data[schemaField.name]) {
            content.data[schemaField.name] = {};
          }
          if (schemaField.properties.fieldType === 'References') {
            if (schemaField.properties.editor === 'Checkboxes' ||
            schemaField.properties.editor === 'Tags' ||
            schemaField.properties.editor === 'Dropdown') {

              if (formGroupValue instanceof Array) {

                if(formGroupValue[0] && formGroupValue[0].item_id) {

                  content.data[schemaField.name]['iv'] = formGroupValue.map(v => {
                    if(v.item_id) {
                      return v.item_id;
                    }
                    return v;
                  });
                } else {
                  content.data[schemaField.name]['iv'] = formGroupValue;
                }

                // TODO: Cleaning needed here
              } else if (Validation.isValidGuid(formGroupValue)) {
                content.data[schemaField.name]['iv'] = [formGroupValue];
              }
            } else if (formGroupValue instanceof Array) {
              content.data[schemaField.name]['iv'] = formGroupValue;
            } else  if (Validation.isValidGuid(formGroupValue)) {
              content.data[schemaField.name]['iv'] = [formGroupValue];
            } else {
              content.data[schemaField.name]['iv'] = [];
            }
          } else if (schemaField.properties.fieldType === 'Boolean') {
            content.data[schemaField.name]['iv'] = formGroupValue === "" ? false : formGroupValue;
          } else if (schemaField.properties.editor === "Date" && schemaField.properties.fieldType === 'DateTime') {
            if (formGroupValue !== "") {
              const dateValue = new SquidexDate(formGroupValue).formatWithoutTime();
              if (dateValue === '') {
                content.data[schemaField.name]['iv'] = null;
              } else {
                content.data[schemaField.name]['iv'] = dateValue;
              }
            }
          }
          else if (schemaField.properties.fieldType === 'DateTime') {
            if (formGroupValue !== "") {
              const dateValue = new SquidexDate(formGroupValue).format();
              if (dateValue === '') {
                content.data[schemaField.name]['iv'] = null;
              } else {
                content.data[schemaField.name]['iv'] = dateValue;
              }
            }
          } 
          else if (schemaField.properties.fieldType === "Number") {
            content.data[schemaField.name]['iv'] = Number(formGroupValue);
          } else if (schemaField.properties.fieldType === "Assets") {
            if(formGroupValue instanceof Array) {
              content.data[schemaField.name]['iv'] = formGroupValue;
            } else {
              content.data[schemaField.name]['iv'] = [];
            }

          } else if (schemaField.properties.editor === 'TextArea' && typeof CKEDITOR !== "undefined" && CKEDITOR && CKEDITOR.instances) {
            for (const instance in CKEDITOR.instances) {
              let textLang: string = CKEDITOR.instances[instance].element.$.nodeName;
              if (textLang.toLowerCase() === (schemaField.name).toLowerCase()) {
                content.data[schemaField.name]['iv'] = CKEDITOR.instances[instance].getData();
              }
            }
          }  else {
            content.data[schemaField.name]['iv'] = formGroupValue;
          }

        } else if (schemaField.partitioning === 'language') {
          if (!content.data[schemaField.name]) {
            content.data[schemaField.name] = {};
          }

          availableLanguages.map(language => language.data.code.iv).forEach(language => {
            if (formGroup.value[`${schemaField.name}_${language}`] || formGroup.value[`${schemaField.name}_${language}`] == "") {
              if (schemaField.properties.fieldType === 'References' || (schemaField.properties.fieldType === 'String' && schemaField.properties.allowedValues && schemaField.properties.allowedValues.length > 0 )) {
                if (formGroupValue instanceof Array) {
                  content.data[schemaField.name][language] = formGroup.value[`${schemaField.name}_${language}`];
                } else if (Validation.isValidGuid(formGroup.value[`${schemaField.name}_${language}`])) {
                  content.data[schemaField.name][language] = [formGroup.value[`${schemaField.name}_${language}`]];
                } else {
                  content.data[schemaField.name][language] = [];
                }
              } else if (schemaField.properties.editor === 'TextArea' && typeof CKEDITOR !== "undefined" && CKEDITOR && CKEDITOR.instances) {
                for (const instance in CKEDITOR.instances) {
                  let textLang: string = CKEDITOR.instances[instance].element.$.nodeName;
                  if (textLang.toLowerCase() === (schemaField.name + '_' + language).toLowerCase() ) {
                    content.data[schemaField.name][language] = CKEDITOR.instances[instance].getData();
                  }
                }
              } else {

                content.data[schemaField.name][language] = formGroup.value[`${schemaField.name}_${language}`];
              }
            }
          });
        }
      });
      return content;
    }
  }
